export const mobileReg = /^0?(11|12|13|15|16|17|18|19|14)[0-9]{9}$/;
/**
 *
 * @param rule
 * @param value
 * @param callback
 * @param isExist 是否验证唯一性
 */
export const mobile = (rule, value, callback) => {
  console.log(value);
  if (value === '') {
    callback(new Error('请输入手机号'));
  } else if (!mobileReg.test(value)) {
    callback(new Error('请输入正确的手机号'));
  } else {
    callback();
  }
};

// 验证是否是手机号或者固定电话
export const isPhone = /^(0[0-9]{2,3}\-)([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$/;
export const mobilePhone = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请输入手机号或固定电话'));
  } else if (!isPhone.test(value) && !mobileReg.test(value)) {
    callback(new Error('请输入正确的手机号或固定电话'));
  } else {
    callback();
  }
};

export const emailReg =
  /^([a-zA-Z0-9]+[_|\_|\.|\-]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.|\-]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
export const email = (rule, value, callback, isRequired = true) => {
  if (isRequired === false && value == '') {
    callback();
    return;
  }
  if (!emailReg.test(value)) {
    callback(new Error('请输入正确的邮箱地址'));
  } else {
    callback();
  }
};
export const identifyingCode = (rule, value, callback, identifyCode = '') => {
  if (value === '') {
    callback(new Error('请输入验证码'));
  } else if (value.toLowerCase() != identifyCode.toLowerCase()) {
    callback(new Error('输入验证码错误'));
  } else {
    callback();
  }
};
export const messageCode = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请输入短信验证码'));
  } else {
    callback();
  }
};
export const emailCode = (rule, value, callback) => {
  // console.log('邮箱验证码验证：', rule);
  if (value === '') {
    callback(new Error('请输入邮箱验证码'));
  } else {
    callback();
  }
};

export const postalCode = (rule, value, callback, code) => {
  let postalCodeReg = /^[0-9]{6}$/;
  if (['FO', 'IS', 'LS', 'TW'].includes(code)) {
    postalCodeReg = /^[0-9]{3}$/;
  } else if (
    [
      'AR',
      'AT',
      'BE',
      'CH',
      'CR',
      'CY',
      'DK',
      'HU',
      'LI',
      'LU',
      'NO',
      'NZ',
      'PH',
      'SI',
      'TN',
      'VE',
      'ZA',
    ].includes(code)
  ) {
    postalCodeReg = /^[0-9]{4}$/;
  } else if (
    [
      'DE',
      'DZ',
      'ES',
      'FI',
      'FR',
      'GR',
      'HR',
      'ID',
      'IL',
      'IR',
      'IT',
      'KW',
      'MC',
      'MX',
      'MY',
      'SA',
      'TH',
      'TR',
      'UA',
      'VN',
    ].includes(code)
  ) {
    postalCodeReg = /^[0-9]{5}$/;
  } else if (['CN', 'IN', 'KZ', 'NP', 'RU', 'SG', 'SK'].includes(code)) {
    postalCodeReg = /^[0-9]{6}$/;
  } else if (['JP', 'RO'].includes(code)) {
    postalCodeReg = /^[0-9]{7}$/;
  } else if (['BR'].includes(code)) {
    if (value === '') {
      callback(new Error('请输入邮政编码'));
    } else if (value.length !== 9) {
      callback(new Error('请输入正确的邮政编码'));
    } else {
      callback();
    }
    return;
  } else if (['AU'].includes(code)) {
    postalCodeReg = /^[0-9]{1,6}$/;
  } else if (['KP', 'GB', 'CL'].includes(code)) {
    if (value === '') {
      callback(new Error('请输入邮政编码'));
    } else if (value.length >= (code === 'GB' ? 9 : 7)) {
      callback(new Error('请输入正确的邮政编码'));
    } else {
      callback();
    }
    return;
  } else if (code === 'CA') {
    postalCodeReg = /^[a-zA-Z][0-9][a-zA-Z][\s][0-9][a-zA-Z][0-9]$/;
  } else if (code === 'CZ') {
    postalCodeReg = /^[0-9]{3}[\s][0-9]{2}$/;
  } else if (code === 'NL') {
    postalCodeReg = /^[0-9]{4}[\s][a-zA-Z]{2}$/;
  } else if (code === 'PL') {
    postalCodeReg = /^[0-9]{2}[-][0-9]{4}$/;
  } else if (code === 'KR') {
    postalCodeReg = /^[0-9]{3}[-][0-9]{3}$/;
  } else if (code === 'US') {
    postalCodeReg = /(^[0-9]{5})$|(^[0-9]{5}[-][0-9]{4}$)/;
  } else if (code === 'PT') {
    postalCodeReg = /(^[0-9]{4})$|(^[0-9]{4}[-][0-9]{3}$)/;
  } else if (code === 'SE') {
    if (value === '') {
      callback(new Error('请输入邮政编码'));
    } else if (value.length !== 6) {
      callback(new Error('请输入正确的邮政编码'));
    } else {
      callback();
    }
    return;
  }
  if (value === '') {
    callback(new Error('请输入邮政编码'));
  } else if (!postalCodeReg.test(value)) {
    callback(new Error('请输入正确的邮政编码'));
  } else {
    callback();
  }
};

const nameReg = /^([a-zA-Z0-9\-\.\_]){6,20}$/;
const numReg = /^[0-9]*$/;
export const loginAccount = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请输入用户名'));
  } else if (!nameReg.test(value)) {
    callback(new Error('6-20个字符，支持字母、数字，"-"及"_"组合！'));
  } else if (numReg.test(value)) {
    callback(new Error('用户名不能全为数字'));
  } else {
    callback();
  }
};

export const validateStrLen = (value) => {
  let len = 0;
  for (let i = 0; i < value.length; i++) {
    const c = value.charCodeAt(i);
    // 单字节加1
    if ((c >= 0x0001 && c <= 0x007e) || (c >= 0xff60 && c <= 0xff9f)) {
      len++;
    } else {
      len += 2;
    }
  }
  return len;
};

export function checkName(rule, value, callback) {
  // const reg = /^(?!.*?[\u3000-\u303F\u4DC0-\u4DFF\u2800-\u28FF\u3200-\u32FF\u3300-\u33FF\u2700-\u27BF\u2600-\u26FF\uFE10-\uFE1F\uFE30-\uFE4F])[\u4e00-\u9fbb\u2E80-\uFE4Fa-zA-Z0-9.`·]+$/;
  const reg = /^[a-zA-Z0-9\u4e00-\u9fa5]+$/;
  if (!reg.test(value)) {
    callback(new Error('请不要输入特殊字符'));
  } else if (validateStrLen(value) > 20) {
    callback(new Error('请不要超过20个字符(字母1个字符,文字2个字符)'));
  }
  callback();
}

// 校验 统一信用社会代码
export function validateCreditCode(rule, value, callback) {
  const reg = /^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/;
  if (!reg.test(value)) {
    callback(new Error('请输入正确的统一信用代码'));
  } else {
    callback();
  }
}
export const idCardReg =
  /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i;
export function idCardValidity(rule, code, callback) {
  const city = {
    11: '北京',
    12: '天津',
    13: '河北',
    14: '山西',
    15: '内蒙古',
    21: '辽宁',
    22: '吉林',
    23: '黑龙江 ',
    31: '上海',
    32: '江苏',
    33: '浙江',
    34: '安徽',
    35: '福建',
    36: '江西',
    37: '山东',
    41: '河南',
    42: '湖北 ',
    43: '湖南',
    44: '广东',
    45: '广西',
    46: '海南',
    50: '重庆',
    51: '四川',
    52: '贵州',
    53: '云南',
    54: '西藏 ',
    61: '陕西',
    62: '甘肃',
    63: '青海',
    64: '宁夏',
    65: '新疆',
    71: '台湾',
    81: '香港',
    82: '澳门',
    91: '国外 ',
  };
  let tip = '';
  let pass = true;
  if (
    !code ||
    !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(
      code
    )
  ) {
    tip = '身份证号格式错误';
    pass = false;
  } else if (!city[code.substr(0, 2)]) {
    tip = '地址编码错误';
    pass = false;
  } else {
    // 18位身份证需要验证最后一位校验位
    if (code.length === 18) {
      code = code.split('');
      // ∑(ai×Wi)(mod 11)
      // 加权因子
      const factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
      // 校验位
      const parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
      let sum = 0;
      let ai = 0;
      let wi = 0;
      for (let i = 0; i < 17; i++) {
        ai = code[i];
        wi = factor[i];
        sum += ai * wi;
      }
      if (parity[sum % 11] != code[17]) {
        tip = '校验位错误';
        pass = false;
      }
    }
  }
  if (!pass) {
    callback(new Error(tip));
  } else {
    callback();
  }
}
